// extracted by mini-css-extract-plugin
module.exports = {"container":"MatchLineupWrapper_container__AnyQG","header":"MatchLineupWrapper_header__9qM_I"};